import { MIXED_PRIORITY_ID, TOTAL_PRIORITY_ID } from '@pflegia/types/common/constants/invite-statistics';

import { CandidatePriority } from '../candidate/candidate-priority';

export const NULL_EMPLOYEE = 'NULL';

export const INVITE_STAT_PRIORITIES = [
  CandidatePriority.A,
  CandidatePriority.B,
  CandidatePriority.B2,
  CandidatePriority.B3,
  CandidatePriority.B4,
  CandidatePriority.B5,
  CandidatePriority.B6,
  CandidatePriority.C,
  CandidatePriority.D1,
  CandidatePriority.D2,
  CandidatePriority.E,
  CandidatePriority.F,
  MIXED_PRIORITY_ID,
  TOTAL_PRIORITY_ID,
] as const;

export type InviteStatPriority = (typeof INVITE_STAT_PRIORITIES)[number];
